export default require('./get-app');



// WEBPACK FOOTER //
// ./client/components/landing/get-app/index.es6